import { Button, Col, Container, Row } from "react-bootstrap";
import Helmet from "../components/Helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faShoppingBag } from "@fortawesome/free-solid-svg-icons";

function SnapBenefits() {
    return (
        <>
            <Helmet title={'SNAP/EBT Benefits'}></Helmet>
            <Container fluid className="d-flex justify-content-center align-items-center default-banner-container banner-container banner-image-container">
                <div><h1 className="display-2">SNAP/EBT Benefits</h1></div>
            </Container>

            <Container className="my-5 bg-light">
                <Row className="info-container justify-content-between align-items-center">
                    <Col sm={12} md={7} className="ps-md-5">
                        <div className="mt-5 my-3">
                            <h3 className="display-5">What is SNAP?</h3>
                            <p>The Supplemental Nutrition Assistance Program (SNAP) issues electronic benefits that can be used like cash to purchase food. SNAP helps low-income working people, senior citizens, the disabled and others feed their families.</p>

                        </div>
                        <div className="mt-5 my-3">
                            <h5>Information and Resources</h5>
                            <h3 className="display-5">What is ACCESS HRA?</h3>
                            <p>The Human Resources Administration (HRA) ACCESS HRA website and free mobile app allow you to get information, apply for benefit programs, and view case information online.</p>
                            <p><a className="h6" href="https://a069-access.nyc.gov/accesshra/" rel="noopener noreferrer" target="_blank">Learn more <em className="text-success">ACCESS HRA</em></a></p>
                        </div>
                    </Col>
                    <Col sm={12} md={4} className="p-0">
                        <img className="img-fluid w-100" src={`${process.env.PUBLIC_URL}/assets/shopping.jpg`} loading="lazy" alt="6 various farm produce" />
                    </Col>
                </Row>
            </Container>

            <Container fluid className="bg-light bg-gradient">
                <Container>
                    <Row className="info-container justify-content-center align-items-center">
                        <Col sm={12} md={4} className="p-0">
                            <img className="img-fluid w-100" src={`${process.env.PUBLIC_URL}/assets/landing/mix-veggies.png`} loading="lazy" alt="cart full of lettuce" />
                        </Col>
                        <Col sm={12} md={8}>

                            <div className="ps-5">
                                <h3 className="display-5">We Accept SNAP EBT Benefits</h3>
                                <p>The Bronx Park East CSA welcomes customers to use their SNAP/EBT benefits on seasonal shares at all locations.</p>
                                <Row>
                                    <Col md={6}>
                                        <h2>SNAP Eligible Food:</h2>
                                        <ul>
                                            <li>All fruits</li>
                                            <li>Meat, fish, poultry</li>
                                            <li>Cheese and all dairy products</li>
                                            <li>Eggs</li>
                                            <li>Baked goods, intended for offsite consumption</li>
                                            <li>Processed foods</li>
                                            <li>Maple/honey/cider/juices</li>
                                            <li>Herbs - plants, dried, bunched</li>
                                            <li>Plants and seedlings that bear food</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <h2>Ineligible Products:</h2>
                                        <ul>
                                            <li>Non food products</li>
                                            <li>Wine &amp; alcohol products</li>
                                            <li>Hot foods</li>
                                            <li>Foods meant to be eaten on-site</li>
                                        </ul>
                                    </Col>
                                </Row>
                                <h2>What we do?</h2>
                                <ul>
                                    <li>We swipe your card at the welcome table</li>
                                    <li>We are going <strong>paperless</strong>! <em>We provide receipts via <strong>email and/or text message</strong>.</em></li>
                                    <li>Enjoy your farm fresh food!</li>
                                </ul>

                            </div>

                        </Col>
                    </Row>
                </Container>
            </Container>

            <Container className="text-center my-5">
                <h4>Half Off Farm Box</h4>
                <p>New Yorkers who participate in <strong>Supplemental Nutrition Assistance Program (SNAP)</strong> receive a pre-assembled box of locally grown farm fresh vegetables for half off the price of our full box.</p>
                <div className="col-2 mx-auto bg-success text-white py-2 mb-3"><p className="fs-1 fw-bolder mb-0"><sup>$</sup>11</p></div>
                <p>Payments are made in-person on day of pickup. Please email <a href="mailto:bronx@ubhealthyproject.org?subject = BxParkEastCSA%20Holiday%20Box&body = Message">bronx@ubhealthyproject.org</a> or call <a href="tel:+13473917189">+1-347-391-7189</a> to pay summer share.</p>
                <p><Button href="/snap" size="lg" variant="warning">Learn more <FontAwesomeIcon icon={faInfoCircle} /></Button>{''} <Button href="https://ubhp.org/csa" size="lg" variant="outline-success">Pre-Order (SNAP/EBT) <FontAwesomeIcon icon={faShoppingBag} /></Button>{''}</p>
            </Container>
        </>
    );

}

export default SnapBenefits;
